



















































import VueFramework from 'vue'
import {Component, Vue, Watch, Prop} from 'vue-property-decorator';
import * as postRecord from '../../store/Posts/PostRecord'
import { Editor } from '@progress/kendo-editor-vue-wrapper'
import { EditorTool } from '@progress/kendo-editor-vue-wrapper'
import { EditorInstaller } from '@progress/kendo-editor-vue-wrapper'
import {PostsApi} from "../../repository/PostsApi";
import {Post, UpdatePost} from "../../repository/messagehub.dtos";

VueFramework.use(EditorInstaller)
@Component({
    components: {


    },
    name: 'EditPost',
})
export default class EditPost extends Vue{
    @Prop({default: false})showEditor!:boolean
    @Prop({default: ''})htmlText!: string
    @Prop()post!:any

    postApi: PostsApi = new PostsApi()
    async onFocusLost(){
        await this.onUpdatePost()
    }
    async onUpdatePost(){
        let editor:any = this.$refs.editPostEditor;
        let widget = editor.kendoWidget()
        let update = new UpdatePost(postRecord.getSelectedPosts(this.$store).id, widget.value())
        //this.post.content = widget.value()
        let result = await this.postApi.updatePost(update)

        if (result.status == 200){
            postRecord.updatePost(this.$store, <Post>result.data.data)
        }
        this.$emit('onUpdatePost', result)

    }
    onCancelUpdatePost(){
        this.$emit('onCancelUpdatePost')
    }
}
